import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useTheme,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  Switch,
  Typography,
  IconButton,
  Box,
  InputLabel,
  FormHelperText,
  ListItemText,
  Stack,
  Paper,
  SelectChangeEvent,
  Chip,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import {
  AGENT,
  MODELS,
  TEAMS,
  USER_MEMBER_GROUPS,
} from "../../../Services/Endpoint";
import { MultiAgent } from "../../../Shared-ui/Types/MultiAgent";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import {
  capitalizeFirstLetter,
  isOnlyAlphabets,
  isOnlyAlphabetsNumbers,
} from "../../../Shared-ui/utils/Common/Common";
import { Agent } from "../../../Shared-ui/Types/Agent";
import Templates from "../../../Constant/Templates";
import Template from "../../../Shared-ui/Types/Template";
import { NotSelected } from "../../../Constant/Setting";
import SearchIcon from "@mui/icons-material/Search";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import variables from "../../../assets/styles/variables.module.scss";
import MultiAgents from "../MultiAgents";
import {
  multiAgentErrInitial,
  multiAgentInitial,
} from "./MultiAgentInitialData";

interface MyComponentProps {
  open: boolean;
  handleClose: () => void;
  multiAgent: MultiAgent | null;
}

const CreateMultiAgent: React.FC<MyComponentProps> = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [multiAgentMode, setMultiAgentMode] = useState<string[]>([
    "route",
    "coordinate",
    "collaborate",
  ]);
  const [multiAgent, setMultiAgent] = useState<MultiAgent>(multiAgentInitial);
  console.log(multiAgent, "multiAgent");
  
  const [multiAgentErr, setMultiAgentErr] = useState(multiAgentErrInitial);
  // const [models, setModels] = useState<{ label: string; value: string }[]>([])
  const [agents, setAgents] = useState<Agent[]>([]);
  const [modelsAndProvider, setModelsAndProvider] = useState();
  const [providers, setProviders] = useState<string[]>([]);
  const [models, setModels] = useState<string[]>([]);
  const [selectedProvider, setSelectedProvider] = useState<string>(NotSelected);

  const [isEditing, setIsEditing] = useState(false);

  const [category, setCategories] = useState<any>([]);
  const [activeCategory, setActiveCategory] = useState("All Templates");
  const [filteredTemplates, setFilteredTemplates] =
    useState<Template[]>(Templates);
  const [search, setSearch] = useState("");
  const [searchAgent, setSearchAgent] = useState("");

  const [userGroups, setUserGroups] = useState<any[]>([]);
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const [unSelectedGroups, setUnSelectedGroups] = useState<string[]>([]);

  const [viewTemplate, setViewTemplate] = useState<Template | null>(null);
  const [openInstructionDialog, setOpenInstructionDialog] = useState(false);
  const [groupSearch, setGroupSearch] = useState("");
  const [showTemplatesPanel, setShowTemplatesPanel] = useState(false);
  // const [viewTemplate, setViewTemplate] = useState<Template | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
  // const handleViewClick = (template: Template) => {
  //   setViewTemplate(template);
  //   setOpenDialog(true);
  // };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setViewTemplate(null);
  };

  useEffect(() => {
    // Check if all required agent fields are filled (returns true/false)
    const requiredFieldsFilled =
      !!multiAgent.name.trim() &&
      !!multiAgent.description.trim() &&
      multiAgent.model !== NotSelected &&
      multiAgent.team_mode !== NotSelected &&
      selectedProvider !== NotSelected &&
      !!multiAgent.instructions[0]?.trim() &&
      multiAgent.agent_ids.length > 0 
      // &&!!multiAgent.api_key.trim();

    setDisableSubmit(!requiredFieldsFilled);
  }, [multiAgent, selectedProvider]);

  useEffect(() => {
    if (props.open) {
      setMultiAgent(multiAgentInitial);
      setMultiAgentErr(multiAgentErrInitial);
      setIsEditing(false);
      setSelectedProvider(NotSelected);
      setModels([]);
      getAgents();
      getUserGroups();
      if (props.multiAgent?.id) {
        getAgentGroups(props.multiAgent?.id || "");
      }
    }
  }, [props.open]);

  useEffect(() => {
    getModels();
  }, []);

  useEffect(() => {
    if (props.multiAgent) {
      setMultiAgent((preVal) => {
        return { ...preVal, ...props.multiAgent };
      });

      setIsEditing(true);
      if (props.multiAgent.model && modelsAndProvider) {
        const provider = props.multiAgent.model.split(":")[0];
        setSelectedProvider(provider);
        if (
          Object.prototype.hasOwnProperty.call(modelsAndProvider, provider) &&
          modelsAndProvider
        ) {
          const models = modelsAndProvider[provider];
          setModels(models);
        }
      }
    } else {
      setMultiAgent({ ...multiAgentInitial, model: NotSelected });
      setSelectedProvider(NotSelected);
      setModels([]);
      setIsEditing(false);
    }
  }, [props.multiAgent, modelsAndProvider]);
  useEffect(() => {
    setMultiAgentErr((prevErr) => {
      const newErr = { ...prevErr };
      let changed = false;

      if (
        prevErr.name.value &&
        multiAgent.name.trim() &&
        isOnlyAlphabetsNumbers(multiAgent.name)
      ) {
        newErr.name = { error: "", value: false };
        changed = true;
      }

      if (prevErr.description.value && multiAgent.description.trim()) {
        newErr.description = { error: "", value: false };
        changed = true;
      }

      if (prevErr.model.value && multiAgent.model !== NotSelected) {
        newErr.model = { error: "", value: false };
        changed = true;
      }

      if (prevErr.instructions.value && multiAgent.instructions.length > 0) {
        newErr.instructions = { error: "", value: false };
        changed = true;
      }
      if (prevErr.provider.value && selectedProvider !== NotSelected) {
        newErr.provider = { error: "", value: false };
        changed = true;
      }

      return changed ? newErr : prevErr;
    });
  }, [multiAgent, selectedProvider]);

  useEffect(() => {
    const categoryCounts: { [key: string]: number } = {};

    Templates.forEach((template) => {
      const cat = template.category;
      categoryCounts[cat] = (categoryCounts[cat] || 0) + 1;
    });

    // Convert to array of JSON objects
    const categoryArray = Object.entries(categoryCounts).map(
      ([category, count]) => ({
        category,
        count,
      })
    );
    setCategories([
      { category: "All Templates", count: Templates.length },
      ...categoryArray,
    ]);
  }, []);

  // function getModelOptions(modelData: Record<string, string[]>): { label: string; value: string }[] {
  //   const options: { label: string; value: string }[] = [];

  //   for (const provider in modelData) {
  //     if (Object.prototype.hasOwnProperty.call(modelData, provider)) {
  //       const models = modelData[provider];
  //       for (const model of models) {
  //         options.push({
  //           label: `${provider} — ${model}`,
  //           value: `${provider}:${model}`
  //         });
  //       }
  //     }
  //   }
  //   return options;
  // }

  const providerOption = (modelData: Record<string, string[]>) => {
    const options = [];
    for (const provider in modelData) {
      options.push(provider);
    }
    setProviders(options);
  };

  const handleSelectAgent = (knowledge: Agent) => {
    setMultiAgent((preVal) => {
      const agentIds = preVal.agent_ids;
      if (knowledge.id) {
        const newAgentIds = agentIds.includes(knowledge.id)
          ? agentIds.filter((id) => id !== knowledge.id)
          : [...agentIds, knowledge.id];
        return {
          ...preVal,
          agent_ids: newAgentIds,
        };
      } else {
        return {
          ...preVal,
          agent_ids: agentIds,
        };
      }
    });
  };

  const getAgents = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(`${AGENT}?page=${1}&page_size=${100}&ready_only=true`
      ).then((res) => res?.data);
      data?.items?.sort(
        (a: { created_at: string }, b: { created_at: string }) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
    
      setAgents(data.items || []);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const getModels = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(MODELS).then((res) => res?.data);
      providerOption(data);
      setModelsAndProvider(data);
      setModels(models);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const createMultiAgent = async () => {
    if (!validateMultiAgent()) return;
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(TEAMS, multiAgent).then(
        (res) => res?.data
      );
      if (selectedGroups.length > 0) {
        await shareAgentToGroup(data.id);
      }
      if (unSelectedGroups.length > 0) {
        await unShareAgentToGroup(data.id);
      }
      handleClose();
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const updateMultiAgent = async () => {
    if (!validateMultiAgent()) return;
    if (!multiAgent.id) return;
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.put(
        `${TEAMS}/${multiAgent.id}`,
        multiAgent
      ).then((res) => res?.data);
      if (selectedGroups.length > 0) {
        await shareAgentToGroup(multiAgent.id);
      }
      if (unSelectedGroups.length > 0) {
        await unShareAgentToGroup(multiAgent.id);
      }
      handleClose();
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const getAgentGroups = async (agentId: string) => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(
        `${TEAMS}/${agentId}/shared-groups`
      ).then((res) => res?.data);
      setSelectedGroups(
        data.map(
          (group: { user_group_id: any; id: string }) => group.user_group_id
        ) || []
      );
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const validateMultiAgent = () => {
    let error = 0;
    const setError = (field: string, condition: boolean, message: string) => {
      if (condition) {
        setMultiAgentErr((prev) => ({
          ...prev,
          [field]: { error: message, value: true },
        }));
        error += 1;
      } else {
        setMultiAgentErr((prev) => ({
          ...prev,
          [field]: { error: "", value: false },
        }));
      }
    };

    // name
    setError("name", !multiAgent.name.trim(), "Please enter the name");
    setError(
      "name",
      !isOnlyAlphabetsNumbers(multiAgent.name),
      "Please enter the name A-z"
    );

    // description
    setError(
      "description",
      !multiAgent.description.trim(),
      "Please enter the description"
    );

    // model
    setError(
      "model",
      multiAgent.model === NotSelected,
      "Please select the model"
    );
    setError(
      "team_mode",
      multiAgent.team_mode === NotSelected,
      "Please select the mode"
    );
    setError(
      "provider",
      selectedProvider === NotSelected,
      "Please select the provider"
    );
    // setError("provider", selectedProvider === NotSelected, "Please select the provider");

    // instructions
    setError(
      "instructions",
      multiAgent.instructions.length === 0,
      "Please enter the instructions"
    );
    //
    setError(
      "zeasecure_api_key",
      multiAgent.team_metadata?.enable_zeasecure &&
      !multiAgent.team_metadata?.zeasecure_api_key.trim(),
      "Please enter the zeasSecure api key"
    );

    return error === 0 ? true : false;
  };

  const handleChange = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent
  ) => {
    const { name, value } = event.target;
    if (name === "instructions") {
      setMultiAgent((preVal) => ({ ...preVal, [name]: [value] }));
    } else {
      setMultiAgent((preVal) => ({ ...preVal, [name]: value }));
    }
  };

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    const name = event.target.name;
    setMultiAgent((preVal) => ({ ...preVal, [name]: checked }));
  };

  const   handleMetaDataSwitchChanges = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    const name = event.target.name;
    setMultiAgent((preVal) => {
      return {
        ...preVal,
        team_metadata: { ...preVal.team_metadata, [name]: checked },
      };
    });
  };

  const handleMetaDataTextChanges = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setMultiAgent((preVal) => {
      return {
        ...preVal,
        agent_metadata: { ...preVal.team_metadata, [name]: value },
      };
    });
  };

  const handleChangeProvider = (event: SelectChangeEvent) => {
    const provider = event.target.value;
    setSelectedProvider(provider);
    if (
      Object.prototype.hasOwnProperty.call(modelsAndProvider, provider) &&
      modelsAndProvider
    ) {
      const models = modelsAndProvider[provider];
      setModels(models);
    } else {
      setModels([]);
    }
    setMultiAgent((preVal) => ({ ...preVal, model: NotSelected }));
  };

  const handleClose = () => {
    props.handleClose();
    setMultiAgent(multiAgentInitial);
    setMultiAgentErr(multiAgentErrInitial);
    setIsEditing(false);
    setSelectedProvider(NotSelected);
    setModels([]);
  };

  const handleInstructionSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);

    if (value) {
      const matches = Templates.filter((template) =>
        template.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredTemplates(matches);
    } else {
      setFilteredTemplates(Templates);
    }
  };

  const handleCategoryClick = (category: string) => {
    setActiveCategory(category.split(" ")[0]);
    if (category === "All Templates") {
      setFilteredTemplates(Templates);
    } else {
      const matches = Templates.filter(
        (template) => template.category === category
      );
      setFilteredTemplates(matches);
    }
  };

  const handleInstructionTemplateSelect = (template: Template) => {
    setMultiAgent((preVal) => ({
      ...preVal,
      instructions: [template.content],
    }));
    setShowTemplatesPanel(false);
  };

  const handleViewClick = (e: React.MouseEvent, template: Template) => {
    e.stopPropagation();
    setViewTemplate(template);
    setOpenInstructionDialog(true);
  };

  const handleCloseInstructionDialog = () => {
    setOpenInstructionDialog(false);
    setViewTemplate(null);
  };

  const getUserGroups = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(USER_MEMBER_GROUPS).then(
        (res) => res?.data
      );
      setUserGroups(data || []);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const shareSingleAgentToGroup = async (agentId: string, groupId: string) => {
    try {
      const data = await BaseInstance.post(
        `${TEAMS}/${agentId}/share/${groupId}`
      ).then((res) => res?.data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
    }
  };

  const unShareSingleAgentToGroup = async (
    agentId: string,
    groupId: string
  ) => {
    try {
      const data = await BaseInstance.delete(
        `${TEAMS}/${agentId}/share/${groupId}`
      ).then((res) => res?.data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
    }
  };

  const shareAgentToGroup = async (agent_id: string) => {
    try {
      dispatch(StartLoading());
      const sharePromises = selectedGroups.map((groupId) =>
        shareSingleAgentToGroup(agent_id, groupId)
      );
      await Promise.all(sharePromises);
    } catch (error) {
      console.error("Error sharing agent:", error);
    } finally {
      dispatch(StopLoading());
    }
  };

  const unShareAgentToGroup = async (agent_id: string) => {
    try {
      dispatch(StartLoading());
      const unSharePromises = unSelectedGroups.map((groupId) =>
        unShareSingleAgentToGroup(agent_id, groupId)
      );
      await Promise.all(unSharePromises);
    } catch (error) {
      console.error("Error sharing agent:", error);
    } finally {
      dispatch(StopLoading());
    }
  };

  const filteredGroups = userGroups.filter((group) =>
    group.name.toLowerCase().includes(groupSearch.toLowerCase())
  );

  const handleGroupCheck = (groupId: string) => {
    if (groupId) {
      setSelectedGroups((prev) => {
        if (prev.includes(groupId)) {
          // If unchecked, add to unSelectedGroups
          setUnSelectedGroups((unPrev) => [...unPrev, groupId]);
          return prev.filter((uid) => uid !== groupId);
        } else {
          // If checked, remove from unSelectedGroups if present
          setUnSelectedGroups((unPrev) =>
            unPrev.filter((uid) => uid !== groupId)
          );
          return [...prev, groupId];
        }
      });
    }
  };

  return (
    <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth="lg">
      <DialogTitle
        sx={{
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: theme.spacing(2),
        }}
      >
        <Box>
          {isEditing ? (
            <Typography variant="h6">Multi-Agent Settings</Typography>
          ) : (
            <Typography variant="h6">Create Multi-Agent</Typography>
          )}
          <Typography
            variant="subtitle2"
            color="textSecondary"
            sx={{ mt: 0.5 }}
          >
            Define the details of your multi-agent team below.
          </Typography>
        </Box>
        <IconButton onClick={handleClose} sx={{ ml: 1 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            gap: 3,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flex: 2,
            }}
          >
            <FormControl
              fullWidth
              variant="outlined"
              sx={{ mt: 1.5, mb: 2 }}
              error={multiAgentErr.name.value}
            >
              <InputLabel
                shrink
                htmlFor="name"
                sx={{ background: "#fff", px: 0.5 }}
              >
                Name *
              </InputLabel>
              <TextField
                required
                id="name"
                name="name"
                value={multiAgent.name}
                onChange={handleChange}
                error={multiAgentErr.name.value}
                helperText={multiAgentErr.name.error}
                placeholder="Hackernews Team"
                variant="outlined"
                inputProps={{ maxLength: 50 }}
              />
            </FormControl>

            <FormControl
              fullWidth
              variant="outlined"
              sx={{ mb: 2 }}
              error={multiAgentErr.description.value}
            >
              <InputLabel
                shrink
                htmlFor="description"
                sx={{ background: "#fff", px: 0.5 }}
              >
                Description *
              </InputLabel>
              <TextField
                required
                id="description"
                name="description"
                value={multiAgent.description}
                onChange={handleChange}
                error={multiAgentErr.description.value}
                helperText={multiAgentErr.description.error}
                placeholder="A team that searches Hackernews and analyzes top stories"
                multiline
                rows={2}
                variant="outlined"
                inputProps={{ maxLength: 1000 }}
              />
            </FormControl>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexDirection: "column",
              }}
            >
              <Typography variant="caption">
                * Select the provider and model that best suits your agent's
                needs. Different models excel at different tasks.
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={multiAgentErr.provider.value}
                >
                  <InputLabel
                    shrink
                    htmlFor="model"
                    sx={{ background: "#fff", px: 0.5 }}
                  >
                    Provider *
                  </InputLabel>
                  <Select
                    value={selectedProvider || NotSelected}
                    name="provider"
                    onChange={handleChangeProvider}
                    displayEmpty
                    error={multiAgentErr.provider.value}
                    sx={{ minWidth: 180 }}
                  >
                    <MenuItem value={NotSelected}>
                      Please select provider
                    </MenuItem>
                    {/* openAi */}

                    {providers.map((provider, index) => (
                      <MenuItem value={provider} key={index}>
                        {provider}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {multiAgentErr.provider.error}
                  </FormHelperText>
                </FormControl>

                <FormControl
                  fullWidth
                  variant="outlined"
                  error={multiAgentErr.model.value}
                >
                  <InputLabel
                    shrink
                    htmlFor="model"
                    sx={{ background: "#fff", px: 0.5 }}
                  >
                    Provider & Model *
                  </InputLabel>
                  <Select
                    value={multiAgent.model || NotSelected}
                    name="model"
                    onChange={handleChange}
                    displayEmpty
                    error={multiAgentErr.model.value}
                  >
                    <MenuItem value={NotSelected}>Please select model</MenuItem>
                    {/* openAi */}

                    {models.map((model, index) => (
                      <MenuItem
                        value={`${selectedProvider}:${model}`}
                        key={index}
                      >
                        {capitalizeFirstLetter(model)}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* FormHelperText Commented for now. need to show only error message */}
                  {/* <FormHelperText>{multiAgentErr.model.error}</FormHelperText>  */}
                </FormControl>

                <FormControl fullWidth variant="outlined">
                  <InputLabel
                    shrink
                    htmlFor="team_mode"
                    sx={{ background: "#fff", px: 0.5 }}
                    error={multiAgentErr.team_mode.value}
                  >
                    Agent Mode
                  </InputLabel>
                  <Select
                    value={multiAgent.team_mode || NotSelected}
                    name="team_mode"
                    onChange={handleChange}
                    displayEmpty
                    error={multiAgentErr.team_mode.value}
                  >
                    <MenuItem value={NotSelected}>Please select mode</MenuItem>
                    {multiAgentMode.map((mode, index) => (
                      <MenuItem value={mode} key={index}>
                        {capitalizeFirstLetter(mode)}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {multiAgentErr.team_mode.error}
                  </FormHelperText>
                </FormControl>
              </Box>
              <Box sx={{width: '100%'}}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel
                      shrink
                      htmlFor="team_mode"
                      sx={{ background: "#fff", px: 0.5}}
                      error={multiAgentErr.team_mode.value}
                    >
                      API Key *
                  </InputLabel>
                  <TextField 
                      name="api_key"
                      value={multiAgent?.api_key}
                      fullWidth
                      onChange={handleChange}
                  /> 
                </FormControl>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flex: 1,
            }}
          >
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                borderRadius: 2,
                mt: { xs: "0", md: "12px" },
                width: "100%",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={500}
                sx={{ lineHeight: 1, mb: 2 }}
              >
                Team Agents
              </Typography>
              {/* Search box for agents inside Paper */}
              <TextField
                placeholder="Search agents..."
                value={searchAgent}
                onChange={(e) => setSearchAgent(e.target.value)}
                fullWidth
                size="small"
                sx={{ mb: 2 }}
                InputProps={{
                  startAdornment: (
                    <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
                  ),
                }}
              />
              <Box sx={{ maxHeight: 160, overflowY: "auto" }}>
                <Stack spacing={1}>
                  {agents
                    .filter(
                      (agent) =>
                        agent.name
                          .toLowerCase()
                          .includes(searchAgent.toLowerCase()) ||
                        agent.description
                          ?.toLowerCase()
                          .includes(searchAgent.toLowerCase())
                    )
                    .map(
                      (agent, index) =>
                        agent.id && (
                          <FormControlLabel
                            key={agent.id}
                            control={
                              <Checkbox
                                checked={multiAgent.agent_ids.includes(
                                  agent.id
                                )}
                                onChange={() => handleSelectAgent(agent)}
                                sx={{
                                  p: 0,
                                }}
                              />
                            }
                            label={
                              <Stack
                                spacing={0.5}
                                sx={{ alignItems: "flex-start", ml: 1 }}
                              >
                                <Typography variant="body1" fontWeight="bold">
                                  {agent.name}
                                </Typography>
                                {agent.description.length > 38 ? (
                                  <Tooltip
                                    title={agent.description}
                                    placement="top-start"
                                  >
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                      noWrap
                                      sx={{
                                        maxWidth: 250,
                                        lineHeight: "20px",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {agent.description}
                                    </Typography>
                                  </Tooltip>
                                ) : (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    noWrap
                                    sx={{
                                      maxWidth: 250,
                                      lineHeight: "20px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {agent.description}
                                  </Typography>
                                )}
                              </Stack>
                            }
                            sx={{ alignItems: "flex-start" }}
                          />
                        )
                    )}
                </Stack>
              </Box>
            </Paper>
          </Box>
        </Box>

        {/* Team users */}

        <Stack
          spacing={2}
          sx={{
            marginTop: 2,
          }}
        >
          {/* Instructions */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
              alignItems: "stretch",
              minHeight: { md: "392px" },
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: showTemplatesPanel ? "50%" : "100%" },
                mb: { xs: 2, md: 0 },
                transition: "width 0.3s",
                position: "relative",
              }}
            >
              <FormControl fullWidth variant="outlined">
                <InputLabel
                  shrink
                  htmlFor="instructions"
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  Instructions *{" "}
                </InputLabel>
                <TextField
                  placeholder="Enter Multi-Agent Instructions Or Select from Template Gallery"
                  value={multiAgent.instructions[0] || ""}
                  name="instructions"
                  onChange={handleChange}
                  helperText={multiAgentErr.instructions.error}
                  error={multiAgentErr.instructions.value}
                  multiline
                  minRows={8}
                  maxRows={8}
                  fullWidth
                  variant="outlined"
                  inputProps={{ maxLength: 50000 }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "391px",
                      alignItems: "flex-start",
                      paddingBottom: "56px",
                    },
                    "& .MuiInputBase-input": {
                      height: "100% !important",
                      overflow: "auto",
                    },
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "1px",
                    left: "1px",
                    right: "1px",
                    backgroundColor: "background.paper",
                    borderTop: "1px solid",
                    borderColor: "divider",
                    height: "48px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    borderRadius: "0 0 16px 16px",
                    gap: 1,
                    paddingRight: 2,
                  }}
                >
                  <Button
                    variant={showTemplatesPanel ? "contained" : "outlined"}
                    disableElevation
                    size="small"
                    onClick={() => setShowTemplatesPanel((prev) => !prev)}
                    startIcon={<CollectionsBookmarkOutlinedIcon />}
                    sx={{
                      textTransform: "capitalize",
                      py: "0",
                    }}
                  >
                    {showTemplatesPanel
                      ? "Hide Template Gallery"
                      : "Select from Template Gallery"}
                  </Button>
                </Box>
              </FormControl>
            </Box>

            {showTemplatesPanel ? (
              <Box
                sx={{
                  width: { xs: "100%", md: "50%" },
                  transition: "width 0.3s",
                }}
              >
                <Typography variant="subtitle1" gutterBottom>
                  Select Template
                </Typography>
                {/* Search Box */}
                <TextField
                  placeholder="Search Template"
                  value={search}
                  onChange={handleInstructionSearch}
                  size="small"
                  fullWidth
                  // sx={{
                  //   "& .MuiOutlinedInput-root": {
                  //     borderRadius: "8px",
                  //   },
                  // }}
                  InputProps={{
                    startAdornment: (
                      <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
                    ),
                  }}
                />

                <Box sx={{ mt: 1.5 }}>
                  {/* Categories */}
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      mb: 1,
                      overflowX: "auto",
                      pb: 1,
                    }}
                  >
                    {category.map((cat: any) => (
                      <Button
                        key={cat.category}
                        onClick={() => handleCategoryClick(cat.category)}
                        disableElevation
                        variant={
                          activeCategory === cat.category
                            ? "contained"
                            : "outlined"
                        }
                        size="small"
                        sx={{
                          flexShrink: 0,
                          borderRadius: "16px",
                          height: "24px",
                          textTransform: "capitalize",
                          backgroundColor:
                            activeCategory === cat.category
                              ? "primary.main"
                              : "transparent",
                          color:
                            activeCategory === cat.category
                              ? "white"
                              : "text.primary",
                          "&:hover": {
                            backgroundColor:
                              activeCategory === cat.category
                                ? "primary.dark"
                                : "rgba(0,0,0,0.04)",
                          },
                          whiteSpace: "nowrap",
                        }}
                      >
                        {cat.category} ({cat.count})
                      </Button>
                    ))}
                  </Stack>

                  {/* Template Cards */}
                  <Box
                    sx={{
                      maxHeight: "250px", // Adjust height as needed
                      overflowY: "auto",
                      pb: "2px",
                    }}
                  >
                    <Stack
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                      }}
                    >
                      {filteredTemplates.map((template) => (
                        <Box
                          key={template.id}
                          sx={{
                            padding: "8px 16px",
                            border: "1px solid",
                            borderColor:
                              multiAgent.instructions[0] === template.content
                                ? variables.primaryColor
                                : "divider",
                            background:
                              multiAgent.instructions[0] === template.content
                                ? "rgba(1, 174, 238, 0.08)"
                                : "transparent",
                            borderRadius: "8px",
                            cursor: "pointer",
                            position: "relative",
                            overflow: "hidden",
                            "&:hover": {
                              backgroundColor:
                                multiAgent.instructions[0] === template.content
                                  ? "rgba(1, 174, 238, 0.12)"
                                  : "rgba(0,0,0,0.02)",
                            },
                            "&::before": {
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "4px",
                              height: "100%",
                              background: variables.primaryColor,
                              borderRadius: "24px 0 0 24px",
                              display: "block",
                              opacity:
                                multiAgent.instructions[0] === template.content
                                  ? 1
                                  : 1, // stronger bar for selected
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography variant="subtitle1">
                              {template.name}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Button
                                size="small"
                                variant="contained"
                                disableElevation
                                startIcon={
                                  <ElectricBoltIcon sx={{ fontSize: 16 }} />
                                }
                                sx={{
                                  borderRadius: "4px",
                                  px: "12px",
                                  textTransform: "capitalize",
                                  minHeight: "24px",
                                  height: "24px",
                                }}
                                onClick={() =>
                                  handleInstructionTemplateSelect(template)
                                }
                              >
                                Use
                              </Button>
                              <IconButton
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(e, template);
                                }}
                                sx={{
                                  backgroundColor: variables.primaryColor,
                                  color: "#fff",
                                  borderRadius: "4px",
                                  minHeight: "24px",
                                  height: "24px",
                                  "&:hover": {
                                    backgroundColor: variables.primaryColor,
                                  },
                                }}
                              >
                                <VisibilityIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Box>
                          </Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 1 }}
                          >
                            {template.description}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Stack
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 0.5,
                              }}
                            >
                              {template.tags.map((tag) => (
                                <Chip
                                  key={tag}
                                  label={tag}
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    textTransform: "capitalize",
                                    lineHeight: "18px",
                                  }}
                                />
                              ))}
                            </Stack>
                          </Box>
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  width: { xs: "100%", md: "50%" }, // Take up the right side when gallery is closed
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                  height: "391px", // Match the height of the instructions field
                  // alignSelf: "flex-start", // Align to the top
                  // pt: "0px", // To align with the top of the instruction field
                }}
              >
                <Stack
                  spacing={2}
                  sx={{
                    height: "391px",
                    overflowY: "auto",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      border: "1px solid",
                      borderColor: "#c4c4c4",
                      padding: "8px 16px",
                      borderRadius: 1,
                    }}
                  >
                    <Box>
                      <Typography variant="body1">Show Tool Calls</Typography>
                      <FormHelperText>
                        Display tool usage in the conversation
                      </FormHelperText>
                    </Box>
                    <Switch
                      name="show_tool_calls"
                      checked={multiAgent.show_tool_calls}
                      onChange={handleSwitchChange}
                    />
                  </Box>
                  {/* is_shared */}

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      border: "1px solid",
                      borderColor: "#c4c4c4",
                      padding: "8px 16px",
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Box flexGrow={1}>
                        <Typography variant="body1">Shared agent</Typography>
                        <FormHelperText>To share agent</FormHelperText>
                      </Box>
                      <Switch
                        name="is_shared"
                        checked={multiAgent.is_shared}
                        onChange={handleSwitchChange}
                      />
                    </Box>
                    {multiAgent.is_shared && (
                      <Box
                        sx={{
                          width: "100%",
                          maxHeight: 320, // Set a max height for the whole box
                          overflow: "auto", // Enable scrolling for the box
                        }}
                      >
                        <Typography variant="subtitle1" sx={{ mb: 1 }}>
                          Assign groups
                        </Typography>
                        <TextField
                          fullWidth
                          label="Search Users"
                          value={groupSearch}
                          onChange={(e) => setGroupSearch(e.target.value)}
                          placeholder="Search by name"
                          sx={{ mb: 2 }}
                        />
                        <Box sx={{ maxHeight: 391, overflowY: "auto" }}>
                          {filteredGroups.map(
                            (group) =>
                              group.id && (
                                <Box
                                  key={group.id}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 1,
                                  }}

                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedGroups.includes(group.id)}
                                    onChange={() =>
                                      handleGroupCheck(group.id || "")
                                    }
                                    id={`user-checkbox-${group.id}`}
                                  />
                                  <label
                                    htmlFor={`user-checkbox-${group.id}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    {group.name}
                                  </label>
                                </Box>
                              )
                          )}
                        </Box>
                      </Box>
                    )}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      border: "1px solid",
                      borderColor: "#c4c4c4",
                      padding: "8px 16px",
                      borderRadius: 1,
                    }}
                  >
                    {/* <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  > */}
                    <Box flexGrow={1}>
                      <Typography variant="body1">Enable Markdown</Typography>
                      <FormHelperText>
                        Format responses with Markdown
                      </FormHelperText>
                    </Box>
                    <Switch
                      checked={multiAgent.markdown}
                      name="markdown"
                      onChange={handleSwitchChange}
                    />
                    {/* </Box> */}
                  </Box>

                  {/* Enable streaming */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      border: "1px solid",
                      borderColor: "#c4c4c4",
                      padding: "8px 16px",
                      borderRadius: 1,
                    }}
                  >
                    {/* <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    // gap={2}
                    sx={{ mb: 2 }}
                  > */}
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        Enable Streaming
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Streaming response
                      </Typography>
                    </Box>
                    <Switch
                      checked={multiAgent.team_metadata.streaming}
                      name="streaming"
                      onChange={handleMetaDataSwitchChanges}
                    />
                    {/* </Box> */}
                  </Box>



                    {/* Enable User Context Awareness */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                border: "1px solid",
                borderColor: "#c4c4c4",
                padding: "8px 16px",
                borderRadius: 1,
              }}
            >
              <Box flexGrow={1}>
                <Typography variant="subtitle1">Enable User Context Awareness</Typography>
                <Typography variant="body2" color="textSecondary">
                  Agent will have access to current user information
                </Typography>
              </Box>
              <Switch
                checked={multiAgent.team_metadata.user_context_awareness}
                name="user_context_awareness"
                onChange={handleMetaDataSwitchChanges}
              />
            </Box>


                  {/* <Box> */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      border: "1px solid",
                      borderColor: "#c4c4c4",
                      padding: "8px 16px",
                      borderRadius: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                      }}
                    >
                      <Box flexGrow={1}>
                        <Typography variant="subtitle1">
                          Enable ZeaSecure
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Enable ZeaSecure
                        </Typography>
                      </Box>
                      <Switch
                        checked={multiAgent.team_metadata.enable_zeasecure}
                        name="enable_zeasecure"
                        onChange={handleMetaDataSwitchChanges}
                      />
                    </Box>
                    {multiAgent.team_metadata.enable_zeasecure && (
                      <FormControl
                        fullWidth
                        variant="outlined"
                        error={multiAgentErr.zeasecure_api_key.value}
                      >
                        <InputLabel
                          shrink
                          htmlFor="zeasecure_api_key"
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          API Key
                        </InputLabel>
                        <TextField
                          placeholder="ZeaSecure API Key"
                          value={multiAgent.team_metadata.zeasecure_api_key}
                          name="zeasecure_api_key"
                          onChange={handleMetaDataTextChanges}
                          helperText={multiAgentErr.zeasecure_api_key.error}
                          error={multiAgentErr.zeasecure_api_key.value}
                          fullWidth
                          variant="outlined"
                          inputProps={{ maxLength: 255 }}
                        // helperText="A concise description of what this agent does."
                        />
                      </FormControl>
                    )}
                  </Box>
                  {/* </Box> */}
                </Stack>
              </Box>
            )}
          </Box>
        </Stack>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          {viewTemplate && (
            <>
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="h6">{viewTemplate.name}</Typography>
                <IconButton onClick={handleCloseDialog} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {viewTemplate.description}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  {viewTemplate.tags.map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      size="small"
                      sx={{ borderRadius: "4px" }}
                    />
                  ))}
                </Stack>
                <Typography variant="subtitle2" gutterBottom>
                  Instructions:
                </Typography>
                <TextField
                  value={viewTemplate.content}
                  multiline
                  fullWidth
                  minRows={4}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      fontFamily: "monospace",
                    },
                  }}
                />
              </DialogContent>
              <DialogActions
                sx={{ borderTop: "1px solid", borderColor: "divider", p: 2 }}
              >
                <Button
                  onClick={handleCloseDialog}
                  size="small"
                  sx={{
                    textTransform: "none",
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  disableElevation
                  startIcon={<ElectricBoltIcon />}
                  size="small"
                  onClick={() => {
                    handleInstructionTemplateSelect(viewTemplate);
                    handleCloseDialog();
                  }}
                  sx={{ borderRadius: "4px", textTransform: "none" }}
                >
                  Use Template
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </DialogContent>

      <DialogActions sx={{ pb: 2, pr: 3 }}>
        <Button
          variant="outlined"
          disableElevation
          size="large"
          sx={{
            textTransform: "capitalize",
          }}
          onClick={props.handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={disableSubmit}
          sx={{
            textTransform: "capitalize",
          }}
          onClick={() => (isEditing ? updateMultiAgent() : createMultiAgent())}
          disableElevation
        >
          {isEditing ? "Update" : "Create"}
        </Button>
      </DialogActions>
      <Dialog
        open={openInstructionDialog}
        onClose={handleCloseInstructionDialog}
        maxWidth="md"
        fullWidth
      >
        {viewTemplate && (
          <>
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid",
                borderColor: "divider",
                p: 2,
              }}
            >
              <Typography variant="h6">{viewTemplate.name}</Typography>
              <IconButton onClick={handleCloseInstructionDialog} size="small">
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 2, mt: 1 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                {viewTemplate.description}
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mb: 2, mt: 1 }}>
                {viewTemplate.tags.map((tag) => (
                  <Chip
                    key={tag}
                    label={tag}
                    size="small"
                    sx={{ borderRadius: "4px" }}
                  />
                ))}
              </Stack>
              <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
                Instructions:
              </Typography>
              <TextField
                value={viewTemplate.content}
                multiline
                fullWidth
                minRows={4}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontFamily: "monospace",
                    fontSize: "0.875rem",
                  },
                }}
              />
            </DialogContent>
            <DialogActions
              sx={{
                borderTop: "1px solid",
                borderColor: "divider",
                p: 2,
                gap: 1,
              }}
            >
              <Button
                onClick={handleCloseInstructionDialog}
                variant="outlined"
                size="small"
              >
                Close
              </Button>
              <Button
                variant="contained"
                startIcon={<ElectricBoltIcon />}
                size="small"
                onClick={() => {
                  handleInstructionTemplateSelect(viewTemplate);
                  handleCloseInstructionDialog();
                }}
              >
                Use Template
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Dialog>
  );
};

export default CreateMultiAgent;
